import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import ProjectGrid from "../components/ProjectGrid";

function SearchPage({lang}) {

    const [searchParams] = useSearchParams();
    const keyword = searchParams.get('keyword');
    const [pageTitle, setPageTitle] = useState(null);

    const [pageData, setPageData] = useState(null);
    const [noData, setNoData] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [meta, setMeta] = useState({ title: '', description: '' });

    useEffect(() => {
        const fetchPage = async () => {
            try {

                const url = `/api/get-search?keyword=${encodeURIComponent(keyword)}&lang=${lang}`;

                const res = await fetch(url, {
                    method: "GET",
                });

                const result = await res.json();

                if (result.data) {
                    setPageData(result.data);
                    let searchTitle = lang === "ko" ? "검색 결과: " + keyword : "Search Results: " + keyword;
                    let searchDesc = lang === "ko" ? "검색 결과 | " + keyword + " | Eyeline" : "Search Results | " + keyword + " Eyeline";
                    setPageTitle(searchTitle);
                    setMeta({
                        title: searchTitle,
                        description: searchDesc,
                    });
                } else {
                    setPageData(null);
                    setNoData(true);
                }
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPage();

    }, [lang, keyword]);

    useEffect(() => {
        if (meta.title) {
            document.title = meta.title;
        }

        if (meta.description) {
        let descTag = document.querySelector('meta[name="description"]');

        if (!descTag) {
            descTag = document.createElement('meta');
            descTag.setAttribute('name', 'description');
            document.head.appendChild(descTag);
        }

        descTag.setAttribute('content', meta.description);
        }

    }, [meta]);

    if (noData) {

        return (
            <div className="page_not_found">
                <h1>{lang === "ko" ? `결과 없음: ${keyword == null ? '' : keyword}` : `No results: ${keyword == null ? '' : keyword}`}</h1>
                <p>{lang === "ko" ? `다른 키워드를 사용해 보세요` : `Please try another keyword`}</p>
            </div>
        )
    }


    if (pageData)

    return (
        <>
            
            <ProjectGrid title={pageTitle} items={pageData} fromSearch="yes" />


        </>

    )

}

export default SearchPage;